import { useContext, useEffect, useState } from 'react';
import { Grid, LinearProgress } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { useForm } from 'react-hook-form';
import {
  generateUUID,
  CustomPagination,
  checkInfosProduto,
} from 'utils/functions';
import { toastWarning } from 'utils/toast';
import { DropsContext } from 'contexts/DropsContext';
import { DocumentosContext } from 'contexts/DocumentosContext';
import VirtualDrop from 'components/VirtualDrop';
import InputMask from 'components/InputMask';
import Button from 'components/Button';
import localeText from 'utils/localeText';

const ProducaoModal = ({ onSubmit, Itens = [] }) => {
  const defaultValues = { produto_id: null, quantidade: '' };
  const { control, handleSubmit, setValue } = useForm({ defaultValues });
  const { drops } = useContext(DropsContext);
  const { postLoading } = useContext(DocumentosContext);
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(false);
  const isLoading = postLoading || loading;

  useEffect(() => {
    Itens?.map((i) => {
      setItens((prev) => [...prev, { uuid: generateUUID(prev), ...i }]);
    });
  }, []);

  const onAdd = async (values) => {
    if (!values?.produto_id) {
      return toastWarning('Produto obrigatório');
    }

    if (!values?.quantidade || Number(values?.quantidade) <= 0) {
      return toastWarning('Quantidade inválida');
    }

    try {
      setLoading(true);
      const produto = await checkInfosProduto(values);

      const item = {
        produto_id: values?.produto_id,
        descricao: produto?.descricao,
        przent: null,
        quantidade: values?.quantidade,
        Estruturas: produto?.Estruturas?.map((e) => ({
          componente_id: e?.componente_id,
          operacao: e?.operacao,
          sequencia: e?.sequencia,
          quantidade: e?.quantidade,
          perda: e?.perda,
          volume: e?.volume,
          comprimento: e?.comprimento,
          altura: e?.altura,
          largura: e?.largura,
          observacao: e?.observacao,
          produtobase_id: e?.produtobase_id,
          retornavel: e?.retornavel,
        })),
        Processos: produto?.Processos?.map((p) => ({
          operacao: p?.operacao,
          descricao: p?.descricao,
          apontamento: p?.apontamento,
          ccusto_id: p?.ccusto_id,
          tpreparacao: p?.tpreparacao,
          texecucao: p?.texecucao,
          analisa_id: p?.analisa_id,
          aprova_id: p?.aprova_id,
        })),
      };

      setItens((prev) => {
        const newArr = prev?.map((p, i) => ({ ...p, sequencia: i + 1 }));
        const uuid = generateUUID(prev);
        const sequencia = newArr?.length + 1;
        newArr?.push({ ...item, sequencia, uuid });
        return newArr;
      });

      setValue('produto_id', null);
      setValue('quantidade', '');
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onDelete = (id) => {
    setItens((prev) => {
      const newArr = prev
        ?.filter((f) => f?.uuid !== id)
        ?.map((m, i) => ({ ...m, sequencia: i + 1 }));
      return newArr;
    });
  };

  const onCellEditCommit = (e) => {
    setItens((prev) =>
      prev?.map((c) => {
        if (c?.uuid === e?.id && e?.field === 'quantidade') {
          return { ...c, [e?.field]: e?.value };
        } else {
          return { ...c };
        }
      })
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={8} lg={10}>
        <VirtualDrop
          name="produto_id"
          control={control}
          label="Produto"
          options={drops?.Produto}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <InputMask name="quantidade" control={control} label="Quantidade" />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          variant="outlined"
          loading={isLoading}
          onClick={handleSubmit(onAdd)}
        >
          Adicionar
        </Button>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={itens}
          columns={[
            {
              field: 'sequencia',
              headerName: 'Sequência',
              type: 'number',
              width: 100,
              sortable: false,
            },
            {
              field: 'descricao',
              headerName: 'Descrição',
              minWidth: 400,
              flex: 1,
              sortable: false,
            },
            {
              field: 'quantidade',
              headerName: 'Quantidade',
              type: 'number',
              width: 150,
              editable: true,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ id }) => [
                <GridActionsCellItem
                  size="small"
                  icon={<Delete />}
                  label="Excluir"
                  onClick={() => onDelete(id)}
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          density="compact"
          disableColumnMenu
          showCellRightBorder
          loading={isLoading}
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowId={(row) => row?.uuid}
          onCellEditCommit={onCellEditCommit}
          components={{
            LoadingOverlay: LinearProgress,
            Pagination: CustomPagination,
          }}
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          loading={isLoading}
          onClick={() => onSubmit(itens)}
        >
          Finalizar
        </Button>
      </Grid>
    </Grid>
  );
};
export default ProducaoModal;
